import { getMessageFactory } from "../getCaxaWebSocket.js";
const createThumbnailFile = getMessageFactory({
  code: "CREATE_THUMBNAIL_FILE"
});
export { createThumbnailFile };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/external/caxa/directive/createThumbnailFile.js